import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {ModalService} from "../../shared/modal.service";

@Component({
    selector: 're-2fa-bulk-update-dialog',
    templateUrl: './2fa-bulk-update-dialog.component.html',
    styleUrls: ['./2fa-bulk-update-dialog.component.scss'],
    standalone: false
})
export class TwoFctorBulkUpdateDialogComponent implements OnInit {

  constructor( private router: Router, private modalService:ModalService) { }
  filters: any = {};

  ngOnInit(): void {
  }


  /*accept() {
    this.activeModal.close(true);
  }

  close() {
    this.activeModal.close(false);
  }*/

}
